import script from "./VF-statusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./VF-statusBadge.vue?vue&type=script&setup=true&lang=js"

import "./VF-statusBadge.vue?vue&type=style&index=0&id=a4ac69bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4ac69bc"]])

export default __exports__